export enum EModePrelevement {
    APied = 1,
    EnBateau = 2,
    PointsContacts = 3,
    Mixte = 4,
}